import React, { useContext, useState } from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import HeaderActions from '../../../common/DasnboardHeader/HeaderActions';
import AcquisitionList from './AcquisitionList';
import { StateContext } from '../../../store';
import NewAcquisitionList from './NewAcquisitionList';
import DashboardHeader from '../../../common/DasnboardHeader/DashboardHeader';
import AutofpsSelectIcon from '@mui/icons-material/AutofpsSelect';
import { styleBg } from '../../../common/Models/Validations';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AcquisitionMain() {
  const { role } = useContext(StateContext);
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const [meta, setMeta] = useState({ total: 0 });
  const isAdminOrChief = role?.id === 1 || role?.id === 10;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOpen = () => {
    navigate('/management/acquisitions/create')
  }

  const handleDescription = () => {
    if (value === 0) {
      return "New Acquisition"
    } else if (value === 1) {
      return "Approved Acquisition"
    } else if (value === 2) {
      return "Rejected Acquisition"
    } else {
      return "Resubmitted Acquisition"
    }
  }
  return (
    <PageWrapper>
      {role?.id === 3 ? (
        <DashboardHeader title={'Acquisition'} total={meta?.total} IconName={AutofpsSelectIcon} iconColor={'#ff9653'} desc={handleDescription()} btnName={'+ Acquisition'} handleOpen={handleOpen} />
      ) : isAdminOrChief ? (
        <DashboardHeader title={'Acquisition'} total={meta?.total} IconName={AutofpsSelectIcon} iconColor={'#ff9653'} desc={handleDescription()} />
      ) : (
        <DashboardHeader title={'Acquisition'} total={meta?.total} IconName={AutofpsSelectIcon} iconColor={'#ff9653'} desc={handleDescription()} />
      )}
      <Box sx={{ mt: 2 }}>
        <Tabs value={value} variant="scrollable" scrollButtons="auto" onChange={handleChange} aria-label="basic tabs example">
          {[
            role?.id === 3 ? { label: "SUBMITTED ACQUISITION", index: 0 } : { label: "NEW ACQUISITION", index: 0 },
            { label: "APPROVED ACQUISITION", index: 1 },
            { label: "REJECTED ACQUISITION", index: 2 },
            { label: "RESUBMITTED ACQUISITION", index: 3 },
            role?.id === 3 && { label: "FORWARDED TO ADMIN", index: 5 },
          ].filter(Boolean).map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              {...a11yProps(tab.index)}
              sx={{ width: 250, ...styleBg(index, value) }}
            />
          ))}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        {!isAdminOrChief ?
          <AcquisitionList status={'requested'} meta={meta} setMeta={setMeta} /> :
          <NewAcquisitionList meta={meta} setMeta={setMeta} />}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <AcquisitionList status={'approved'} meta={meta} setMeta={setMeta} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <AcquisitionList status={'rejected'} meta={meta} setMeta={setMeta} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <AcquisitionList status={'resubmitted'} meta={meta} setMeta={setMeta} />
      </CustomTabPanel>
      {role?.id === 3 &&
        <CustomTabPanel value={value} index={5}>
          <AcquisitionList status={'forwarded_to_admin'} meta={meta} setMeta={setMeta} />
        </CustomTabPanel>
      }
    </PageWrapper>
  );
}
